import React from 'react';
import { Modal } from 'antd';
export default function AboutModal(props) {
    var visible = props.visible, onCancel = props.onCancel, t = props.t, newVersion = props.newVersion, logoImg = props.logoImg, version = props.version, appName = props.appName, linkConfig = props.linkConfig;
    var linkMap;
    if (linkConfig) {
        linkMap = linkConfig;
    }
    else {
        linkMap = {
            service: 'https://me.jdcloud.com/protocol/service/chinese/',
            privacy: 'https://me.jdcloud.com/protocol/privacy/chinese/',
        };
    }
    return (React.createElement(Modal, { className: "me-about-modal", width: 340, visible: visible, onCancel: onCancel, bodyStyle: {
            padding: 0,
        }, footer: null },
        React.createElement("div", { style: {
                height: 250,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement("div", { className: "me-about-modal-content", style: {
                    flex: 1,
                    // borderBottom: `1px solid ${styles.color.splitLine}`,
                    // ...styles.layout('center', 'v'),
                    paddingTop: 20,
                } },
                React.createElement("img", { alt: "", src: logoImg ||
                        'https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/statics/images/logo.png', width: 72, style: {
                        borderRadius: 12,
                    } }),
                React.createElement("h4", { style: {
                        fontSize: 18,
                        margin: 5,
                    } }, appName || t('AppName')),
                version && (React.createElement("p", { style: {
                        margin: 0,
                        fontSize: 12,
                    } }, "V" + version)),
                newVersion && (React.createElement("p", { style: {
                        margin: 0,
                    } },
                    React.createElement("span", { style: {
                            padding: '3px 10px',
                            borderRadius: 5,
                            fontSize: 10,
                            backgroundColor: 'rgba(245,34,45,0.2)',
                            color: '#F5222D',
                        } }, t('获取新版本'))))),
            React.createElement("div", { className: "me-about-modal-footer", style: {
                    height: 50,
                    padding: 10,
                } },
                React.createElement("a", { href: linkMap.service, target: "_blank", className: "me-about-modal-footer-btn" }, t('software-user-agreement')),
                React.createElement("div", { className: "me-about-modal-footer-splitline", style: {
                        width: 1,
                        height: 13,
                        // backgroundColor: styles.color.splitLine,
                        margin: '0 20px',
                    } }),
                React.createElement("a", { href: linkMap.privacy, target: "_blank", className: "me-about-modal-footer-btn" }, t('software-privacy-agreement'))))));
}
//# sourceMappingURL=index.js.map